<!-- 会员视频列表页 -->
<template>
  <div class='vipVideo'>
    <publicHeader :pageTitle="pageTitle" isWhite='true'></publicHeader>
    <div class="zhanwei">

    </div>
    <div class="tabbar">
      <div class="tabItem" :class="{'heiLight':index===tabIndex}" v-for="(item,index) in tabBar" :key="index" @click="handleTabIndex(index)">
        {{item}}
      </div>
    </div>
    <div class="videosBox" v-if="vipVideos.length">
      <div class="videoItem" v-for="(item,index) in vipVideos" :key="index" @click="gotoVideoDeatil(item.id)">
        <div class="poster">
          <img :src="item.imgUrl" alt="" v-if="item.imgUrl">
          <!-- 会员图标icon -->
          <div class="icon_vip"></div>
          <!-- 视频时长 -->
          <div class="cover">
            <div class="time">{{item.totalTimes |TotalTimeFilter}}</div>
          </div>
        </div>
        <div class="title">
          {{item.title}}
        </div>
      </div>
    </div>
    <div class="noVideo" v-else>
      <div class="nodataImg">
        <img src="https://images.zhibo.tv/2021/0306/icon_nolog.png" alt="">
      </div>
      <div class="nodata">
        暂无数据
      </div>
    </div>
  </div>
</template>

<script>
import publicHeader from '../components/PublicHeader'

export default {
  components: { publicHeader },
  data () {
    return {
      // tabBar
      tabBar: ['最新', '最热'],
      tabIndex: 0,
      perPageNum: 20,
      iPage: 1,
      order: 1,
      vipVideos: [],
      // 用于滚动加载
      isLoading: false,
      pageTitle: '',
      token: ''
    }
  },
  created () {
    // alert(window.location.href)
    this.getToken()
    document.title = "会员专享视频"
    this.pageTitle = '会员专享视频'
    this.getVideoList()
    this.scroll()
  },
  methods: {
    // 获取url上的信息
    getcommit (name) {
      return (
        decodeURIComponent(
          (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(
            location.href
          ) || ["", ""])[1].replace(/\+/g, "%20")
        ) || false
      );
    },
    // 获取token
    getToken () {
      if (this.$CONFIG.isVerify && this.isIOS) {
        this.token = '2a9cc326033c71cd67ac7caba01c2cd0*8028670'
      } else {
        this.token = this.getcommit('token') || ''
      }
      console.log(this.token);
    },
    // 切换最新最热
    handleTabIndex (index) {
      this.tabIndex = index
      this.order = index + 1
      this.vipVideos = []
      this.iPage = 1
      document.body.scrollTop = document.documentElement.scrollTop = 0
      this.getVideoList()

    },
    // 获取会员视频列表
    getVideoList () {
      let params = {
        perPageNum: this.perPageNum,
        iPage: this.iPage,
        token: this.token,
        order: this.order,
        statistics: this.$CONFIG.statistics
      }
      this.$vipapi.getVipVideoList(params).then(res => {
        this.isLoading = false
        this.vipVideos.push(...res.data.data.list)
      })
    },
    // 滚动加载
    scroll () {
      window.onscroll = () => {
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight // document的滚动高度
        const nowScotop = document.documentElement.clientHeight || document.body.clientHeight // 可视区高度
        const wheight = document.documentElement.scrollTop || document.body.scrollTop // 已滚动高度
        // console.log(scrollHeight - nowScotop - wheight, this.isLoading);
        if (scrollHeight - nowScotop - wheight > 0 && scrollHeight - nowScotop - wheight < 100 && !this.isLoading) {
          this.isLoading = true
          this.iPage++
          this.getVideoList()
        }
      }

    },
    // 跳转视频详情
    gotoVideoDeatil (id) {
      try {
        window.webkit.messageHandlers.startVideoRoom.postMessage(id);
      } catch (e) {
        console.log('IOS跳转视频详情失败');
      }

      try {
        window.LiveAppJS.startVideoRoom(id);
      } catch (e) {
        console.log('安卓跳转视频详情失败');
      }
    },
  },
  filters: {
    TotalTimeFilter (val) {
      let seconds = val % 60 > 10 ? val % 60 : '0' + val % 60
      let minutes = Math.floor((val - seconds) / 60 % 60) > 10 ? Math.floor((val - seconds) / 60 % 60) : '0' + Math.floor((val - seconds) / 60 % 60)
      let hours = Math.floor(val / 60 / 60) > 10 ? Math.floor(val / 60 / 60) : '0' + Math.floor(val / 60 / 60)

      let result
      if (hours === '00') {
        result = `${minutes}:${seconds}`
      } else {
        result = `${hours}:${minutes}:${seconds}`
      }
      return result
    }
  },
  destroyed () {
    document.removeEventListener('scroll', this.scroll(), false)
    window.onscroll = null
    window.console.log('销毁了')
  },
}
</script>
<style lang='less' scoped>
@import url('../style/index.less');
// 视频列表
.vipVideo {
  // 顶部切换
  .tabbar {
    width: 100%;
    height: 0.9rem;
    background: #fff;
    border-bottom: 0.01rem solid #e5e5e5;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    top: 0.86rem;
    left: 0;
    z-index: 2;

    font-size: 0.28rem;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #222222;
    .tabItem {
      height: 100%;
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
    }
    .heiLight {
      font-size: 0.28rem;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #222222;
      position: relative;
      &::after {
        content: '';
        width: 0.48rem;
        height: 0.06rem;
        background: linear-gradient(129deg, #ff6945 0%, #ff4834 100%);
        border-radius: 0.03rem;
        position: absolute;
        bottom: 0;
      }
    }
  }

  .videosBox {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 0.3rem;
    margin-top: 0.9rem;
    .videoItem {
      flex-shrink: 0;
      position: relative;
      width: 3.38rem;
      height: 3rem;
      margin-bottom: 0.2rem;
      overflow: hidden;
      background: #ffffff;
      border-radius: 0.1rem;
      border: 0.14vw solid #e5e5e5;
      // .border-all (1px,solid,#e5e5e5,0.1rem);

      box-shadow: 0 0.01rem 0.2em 0.02rem rgba(88, 88, 88, 0.1);
      .poster {
        width: 3.4rem;
        height: 1.9rem;
        border-radius: 0.1rem 0.1rem 0 0;
        position: relative;
        background: url('https://images.zhibo.tv/2020/0416/defimg.png')
          no-repeat center center;
        background-size: 60%;
        img {
          width: 3.4rem;
          height: 1.9rem;
          object-fit: cover;
        }

        .icon_vip {
          width: 0.8rem;
          height: 0.3rem;
          position: absolute;
          top: 0.1rem;
          right: 0.1rem;
          background: url('https://images.zhibo.tv/2020/1104/icon_vip@2x.png')
            no-repeat;
          background-size: 100%;
        }

        .cover {
          position: absolute;
          width: 100%;
          height: 0.7rem;
          bottom: 0;
          left: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: flex-end;
          background: linear-gradient(
            360deg,
            rgba(0, 0, 0, 0.66) 0%,
            rgba(0, 0, 0, 0) 100%
          );

          font-size: 0.22rem;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #ffffff;

          .time {
            margin-right: 0.1rem;
            margin-top: 0.3rem;
          }
        }
      }

      .title {
        margin: 0.15rem 0.1rem;
        text-align: left;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 0.4rem;

        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
  }
  // 暂无数据
  .noVideo {
    .nodataImg {
      width: 2.64rem;
      height: 2.64rem;
      margin: 0 auto;
      margin-top: 2.98rem;
      img {
        display: block;
        width: 2.64rem;
        height: 2.64rem;
      }
    }
    .nodata {
      text-align: center;
      margin-top: 0.2rem;
      font-size: 0.28rem;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999;
    }
  }
}
</style>